import * as React from "react";

const Add: React.FC = () => {
    return <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="3.-Style" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="1.Iconography" transform="translate(-381.000000, -413.000000)" fill="currentColor">
            <g transform="translate(79.000000, 230.000000)">
                <g transform="translate(302.000000, 183.000000)">
                    <polygon points="14 0 10 0 10 10 0 10 0 14 10 14 10 24 14 24 14 14 24 14 24 10 14 10"></polygon>
                </g>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(Add);
